import { default as _91_46_46_46cms_938OnZqse6u2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93agsnjQtbNsMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexqE9tUXsrSHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93PWr6pMt4H4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/akcii/[...slug].vue?macro=true";
import { default as indexIgZ9cvcsVAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93pE1KvWhyR2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/articles/[...slug].vue?macro=true";
import { default as indexNgaHONe0pWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/articles/index.vue?macro=true";
import { default as indextXZShqFKdBMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/authorization/index.vue?macro=true";
import { default as indexQIEkUFRZvzMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93rCWXIz9BX4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93jdLVyN3WhLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalog/[...slug].vue?macro=true";
import { default as index0uQNqojXP1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93xdXGsfhVfOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultG5y6nmm6orMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalogsearch/result.vue?macro=true";
import { default as indexhA5fFawahEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_932lF4macWA1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93QJVJOfKGXfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/fabriki/[...slug].vue?macro=true";
import { default as indexZPukTse1fDMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93ylMgFZqSgoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93NwFinPkXN8Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/product/[...slug].vue?macro=true";
import { default as indexsQ2KMXmffsMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/profile/index.vue?macro=true";
import { default as indexIVbU6Ao61DMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/profile/orders/index.vue?macro=true";
import { default as index8GjuR6Y3FFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93ZOAoKp9iOJMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/sets/[...slug].vue?macro=true";
import { default as indexPyflZT70wjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_938OnZqse6u2Meta?.name ?? "cms",
    path: _91_46_46_46cms_938OnZqse6u2Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_938OnZqse6u2Meta || {},
    alias: _91_46_46_46cms_938OnZqse6u2Meta?.alias || [],
    redirect: _91_46_46_46cms_938OnZqse6u2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93agsnjQtbNsMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93agsnjQtbNsMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93agsnjQtbNsMeta || {},
    alias: _91_46_46_46slug_93agsnjQtbNsMeta?.alias || [],
    redirect: _91_46_46_46slug_93agsnjQtbNsMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexqE9tUXsrSHMeta?.name ?? "3d-projects",
    path: indexqE9tUXsrSHMeta?.path ?? "/3d-projects",
    meta: indexqE9tUXsrSHMeta || {},
    alias: indexqE9tUXsrSHMeta?.alias || [],
    redirect: indexqE9tUXsrSHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93PWr6pMt4H4Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93PWr6pMt4H4Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93PWr6pMt4H4Meta || {},
    alias: _91_46_46_46slug_93PWr6pMt4H4Meta?.alias || [],
    redirect: _91_46_46_46slug_93PWr6pMt4H4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexIgZ9cvcsVAMeta?.name ?? "akcii",
    path: indexIgZ9cvcsVAMeta?.path ?? "/akcii",
    meta: indexIgZ9cvcsVAMeta || {},
    alias: indexIgZ9cvcsVAMeta?.alias || [],
    redirect: indexIgZ9cvcsVAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93pE1KvWhyR2Meta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93pE1KvWhyR2Meta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93pE1KvWhyR2Meta || {},
    alias: _91_46_46_46slug_93pE1KvWhyR2Meta?.alias || [],
    redirect: _91_46_46_46slug_93pE1KvWhyR2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNgaHONe0pWMeta?.name ?? "articles",
    path: indexNgaHONe0pWMeta?.path ?? "/articles",
    meta: indexNgaHONe0pWMeta || {},
    alias: indexNgaHONe0pWMeta?.alias || [],
    redirect: indexNgaHONe0pWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indextXZShqFKdBMeta?.name ?? "authorization",
    path: indextXZShqFKdBMeta?.path ?? "/authorization",
    meta: indextXZShqFKdBMeta || {},
    alias: indextXZShqFKdBMeta?.alias || [],
    redirect: indextXZShqFKdBMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexQIEkUFRZvzMeta?.name ?? "cart",
    path: indexQIEkUFRZvzMeta?.path ?? "/cart",
    meta: indexQIEkUFRZvzMeta || {},
    alias: indexQIEkUFRZvzMeta?.alias || [],
    redirect: indexQIEkUFRZvzMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93rCWXIz9BX4Meta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93rCWXIz9BX4Meta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93rCWXIz9BX4Meta || {},
    alias: _91_46_46_46id_93rCWXIz9BX4Meta?.alias || [],
    redirect: _91_46_46_46id_93rCWXIz9BX4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93jdLVyN3WhLMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93jdLVyN3WhLMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93jdLVyN3WhLMeta || {},
    alias: _91_46_46_46slug_93jdLVyN3WhLMeta?.alias || [],
    redirect: _91_46_46_46slug_93jdLVyN3WhLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index0uQNqojXP1Meta?.name ?? "catalog",
    path: index0uQNqojXP1Meta?.path ?? "/catalog",
    meta: index0uQNqojXP1Meta || {},
    alias: index0uQNqojXP1Meta?.alias || [],
    redirect: index0uQNqojXP1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93xdXGsfhVfOMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93xdXGsfhVfOMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93xdXGsfhVfOMeta || {},
    alias: _91_46_46_46slug_93xdXGsfhVfOMeta?.alias || [],
    redirect: _91_46_46_46slug_93xdXGsfhVfOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultG5y6nmm6orMeta?.name ?? "catalogsearch-result",
    path: resultG5y6nmm6orMeta?.path ?? "/catalogsearch/result",
    meta: resultG5y6nmm6orMeta || {},
    alias: resultG5y6nmm6orMeta?.alias || [],
    redirect: resultG5y6nmm6orMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexhA5fFawahEMeta?.name ?? "clear-page-slider",
    path: indexhA5fFawahEMeta?.path ?? "/clear-page-slider",
    meta: indexhA5fFawahEMeta || {},
    alias: indexhA5fFawahEMeta?.alias || [],
    redirect: indexhA5fFawahEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_932lF4macWA1Meta?.name ?? "collection-slug",
    path: _91_46_46_46slug_932lF4macWA1Meta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_932lF4macWA1Meta || {},
    alias: _91_46_46_46slug_932lF4macWA1Meta?.alias || [],
    redirect: _91_46_46_46slug_932lF4macWA1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QJVJOfKGXfMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93QJVJOfKGXfMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93QJVJOfKGXfMeta || {},
    alias: _91_46_46_46slug_93QJVJOfKGXfMeta?.alias || [],
    redirect: _91_46_46_46slug_93QJVJOfKGXfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexZPukTse1fDMeta?.name ?? "fabriki",
    path: indexZPukTse1fDMeta?.path ?? "/fabriki",
    meta: indexZPukTse1fDMeta || {},
    alias: indexZPukTse1fDMeta?.alias || [],
    redirect: indexZPukTse1fDMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93ylMgFZqSgoMeta?.name ?? "order-status-hash",
    path: _91hash_93ylMgFZqSgoMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93ylMgFZqSgoMeta || {},
    alias: _91hash_93ylMgFZqSgoMeta?.alias || [],
    redirect: _91hash_93ylMgFZqSgoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93NwFinPkXN8Meta?.name ?? "product-slug",
    path: _91_46_46_46slug_93NwFinPkXN8Meta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93NwFinPkXN8Meta || {},
    alias: _91_46_46_46slug_93NwFinPkXN8Meta?.alias || [],
    redirect: _91_46_46_46slug_93NwFinPkXN8Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexsQ2KMXmffsMeta?.name ?? "profile",
    path: indexsQ2KMXmffsMeta?.path ?? "/profile",
    meta: indexsQ2KMXmffsMeta || {},
    alias: indexsQ2KMXmffsMeta?.alias || [],
    redirect: indexsQ2KMXmffsMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexIVbU6Ao61DMeta?.name ?? "profile-orders",
    path: indexIVbU6Ao61DMeta?.path ?? "/profile/orders",
    meta: indexIVbU6Ao61DMeta || {},
    alias: indexIVbU6Ao61DMeta?.alias || [],
    redirect: indexIVbU6Ao61DMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index8GjuR6Y3FFMeta?.name ?? "recently",
    path: index8GjuR6Y3FFMeta?.path ?? "/recently",
    meta: index8GjuR6Y3FFMeta || {},
    alias: index8GjuR6Y3FFMeta?.alias || [],
    redirect: index8GjuR6Y3FFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93ZOAoKp9iOJMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93ZOAoKp9iOJMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93ZOAoKp9iOJMeta || {},
    alias: _91_46_46_46slug_93ZOAoKp9iOJMeta?.alias || [],
    redirect: _91_46_46_46slug_93ZOAoKp9iOJMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexPyflZT70wjMeta?.name ?? "wishlist",
    path: indexPyflZT70wjMeta?.path ?? "/wishlist",
    meta: indexPyflZT70wjMeta || {},
    alias: indexPyflZT70wjMeta?.alias || [],
    redirect: indexPyflZT70wjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922055010/pages/wishlist/index.vue").then(m => m.default || m)
  }
]